import React from "react";
import {
  ProjectBudgetStatus,
  ProjectStatus,
  ProjectTimelineStatus,
  ProjectType,
} from "@src/types";
import { Entries } from "type-fest";
import BudgetStatusNode from "./ProjectPage/BudgetStatusNode";
import TimelineStatusNode from "./ProjectPage/TimelineStatusNode";
import ProjectCategoryNode from "./ProjectPage/ProjectCategoryNode";
import ProjectStatusNode from "./ProjectPage/ProjectStatusNode";
import {
  budgetStatusRenderingOptions,
  projectCategoryRenderingValues,
  projectStatusRenderingOptions,
  timelineStatusRenderingOptions,
} from "./projectRenderingOptions";

export const statusOptions: Array<{
  id: ProjectStatus;
  nodeLabel: React.ReactNode;
}> = (
  Object.entries(projectStatusRenderingOptions) as Entries<
    typeof projectStatusRenderingOptions
  >
).map(([status]) => {
  return {
    id: status,
    nodeLabel: <ProjectStatusNode status={status} hasBackground={false} />,
  };
});

export const categoryOptions: Array<{
  id: ProjectType;
  nodeLabel: React.ReactNode;
}> = (
  Object.entries(projectCategoryRenderingValues) as Entries<
    typeof projectCategoryRenderingValues
  >
).map(([category]) => {
  return {
    id: category,
    nodeLabel: <ProjectCategoryNode projectType={category} />,
  };
});

export const timelineStatusOptions: Array<{
  id: ProjectTimelineStatus;
  nodeLabel: React.ReactNode;
}> = (
  Object.entries(timelineStatusRenderingOptions) as Entries<
    typeof timelineStatusRenderingOptions
  >
).map(([status]) => {
  return {
    id: status,
    nodeLabel: <TimelineStatusNode timelineStatus={status} />,
  };
});

export const budgetStatusOptions: Array<{
  id: ProjectBudgetStatus;
  nodeLabel: React.ReactNode;
}> = (
  Object.entries(budgetStatusRenderingOptions) as Entries<
    typeof budgetStatusRenderingOptions
  >
).map(([status]) => {
  return {
    id: status,
    nodeLabel: <BudgetStatusNode budgetStatus={status} />,
  };
});

export const PROJECT_PATHS = {
  PORTFOLIO_PAGE: "/projects",
  BASE_SITE_PATH: "/site/:siteId/projects",
  SITE_PAGE: "/site/:siteId/projects/all-projects",
  DECARB_PAGE: "/site/:siteId/projects/decarb-planning",
  PROJECT_PAGE: "/site/:siteId/projects/all-projects/:projectId",
} as const;

export const isProjectType = (type: unknown): type is ProjectType => {
  return typeof type === "string" && type in projectCategoryRenderingValues;
};
